const priceDisplayMode = {
  including: {
    value: 'INCLUDING_VAT',
    textValue: 'Inclusief BTW',
  },
  excluding: {
    value: 'EXCLUDING_VAT',
    textValue: 'Exclusief BTW',
  },
  including_and_excluding: {
    value: 'INCLUDING_AND_EXCLUDING_VAT',
    textValue: 'Exclusief & Inclusief BTW',
  },
}

export default priceDisplayMode
